<template>
  <div>
    <div class="row align-items-center">
      <div class="col-12 col-md-6 text-center text-md-left mb-3">
        <form v-on:submit.prevent="listarUsuarios">
          <div class="form-inline justify-content-center justify-content-md-start">
            <div class="form-group mb-2">
              <label for="inputBusca" class="sr-only">Busca</label>
              <input type="text" class="form-control" id="inputBusca" @keypress="selecionarUsuario" v-model="buscaUsuario"
                     placeholder="Buscar usuário">
            </div>
            <button type="submit" class="btn btn-primary btn-busca mb-2 ml-2"><i
              class="fas fa-search"></i></button>
            <small class="ml-3"><a href="javascript:void(0)" @click="limparFiltro" v-if="filtroBusca">Limpar filtro</a></small>
          </div>
        </form>
      </div>
    </div>

    <p class="text-right mt-3" v-if="quantidade"><strong>{{ quantidade }}</strong> itens</p>
    <div class="table-responsive tabela-usuarios mt-3" v-if="usuarios.length">
      <table class="table" ref="resultadoTabelaUsuarios">
        <thead>
          <tr>
            <th></th>
            <th>Usuário</th>
            <th>Nome</th>
            <th>Perfil</th>
            <th>Data de Cadastro</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="estudante in estudantes" v-bind:key="estudante.id">
            <td><img :src="estudante.avatar" /></td>
            <td>{{ estudante.email }}</td>
            <td>{{ estudante.name }}</td>
            <td>{{ estudante.perfil }}</td>
            <td>{{ estudante.dataCriacao }}</td>
            <td>
              <div class="d-flex align-items-center">
                <a href="javascript:void(0)" @click="confirmGerarAcesso(estudante)" v-b-tooltip.hover title="Gerar link de acesso"><i class="fas fa-user-secret"></i></a>
                <a href="javascript:void(0)" @click="obterEstudanteIdParaTrocarEmail(estudante.id)" v-b-modal.modal-trocar-email v-b-tooltip.hover title="Trocar e-mail do aluno"><i class="fas fa-at"></i></a>
                <a href="javascript:void(0)" @click="excluirUsuario( estudante.id )" v-b-modal.modal-excluir-usuario v-b-tooltip.hover title="Excluir aluno/email"><i class="fas fa-user-slash"></i></a>
                <a href="javascript:void(0)" @click="definirSenha( estudante )" v-b-modal.modal-definir-senha v-b-tooltip.hover title="Definir senha do aluno"><i class="fas fa-key"></i></a>
                <a href="javascript:void(0)" v-if="!estudante.email_verified_at" @click="validarEmail( estudante.id )" v-b-modal.modal-validar-email v-b-tooltip.hover title="Validar email do aluno"><i class="fas fa-user-check"></i></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <transition name="fade">
        <div class="btn-top text-center d-block" v-if="scrolled">
          <a href="javascript:void(0)" @click="scrollToTop"><i class="fas fa-chevron-circle-up"></i>ir para o topo</a>
        </div>
      </transition>

    </div>

    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <div slot="no-results">Sua busca não retornou resultados</div>
      <div slot="no-more"></div>
    </infinite-loading>

    <!-- modal trocar e-mail -->

    <ModalTrocaEmail :estudanteId="estudanteIdParaTrocarEmail"></ModalTrocaEmail>

  </div>
</template>

<script>
import ModalTrocaEmail from '@/modules/Usuario/components/ModalTrocaEmail'
import UsuarioAPI from '@/api/usuario-api'
import DateUtils from '@/core/util/date-utils'
import Swal from 'sweetalert2'
import { TipoPerfilUtil } from '@/core/types/tipo-perfil'
import 'jspdf-autotable'
import ResponseUtils from '@/core/util/response-utils'
import InfiniteLoading from 'vue-infinite-loading'

const customSwal = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary mr-3',
    cancelButton: 'btn btn-secondary',
    container: 'container-class modal-conta'
  },
  buttonsStyling: false
})

export default {
  name: 'ListaUsuarios',
  components: { InfiniteLoading, ModalTrocaEmail },
  data () {
    return {
      pagina: 1,
      quantidade: 0,
      buscaUsuario: '',
      filtroBusca: '',
      usuarios: [],
      usuarioEdicao: null,
      infiniteId: new Date(),
      scrolled: false,
      estudanteIdParaTrocarEmail: null
    }
  },

  computed: {
    estudantes: function () {
      return this.usuarios.filter(i => i.perfil_id === 5)
    }
  },

  created () {
    window.addEventListener('scroll', this.handleScroll)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },

  mounted () {
    this.listarUsuarios()
  },

  methods: {

    obterEstudanteIdParaTrocarEmail: async function (estudanteId) {
      this.estudanteIdParaTrocarEmail = estudanteId
    },

    handleScroll: function (event) {
      this.scrolled = window.scrollY > 100
    },

    scrollToTop: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },

    selecionarUsuario: function (event) {
      if (event.key === 'Enter') {
        this.listarUsuarios()
      }
    },

    infiniteHandler: function ($state) {
      UsuarioAPI.listar(this.pagina, this.filtroBusca).then(data => {
        this.quantidade = data.total

        if (this.pagina <= data.last_page) {
          this.usuarios.push(...data.data.map(item => {
            return Object.assign(item, {
              nome: item.name,
              dataCriacao: item.created_at ? DateUtils.formatDate(item.created_at, 'DD/MM/YYYY') : '',
              perfil: TipoPerfilUtil.obterPorId(item.perfil_id).nome
            })
          }))
          $state.loaded()

          if (this.pagina === data.last_page) {
            $state.complete()
          } else {
            this.pagina += 1
          }
        } else {
          $state.complete()
        }
      }).catch(error => ResponseUtils.handleError(error))
    },

    listarUsuarios: function () {
      this.filtroBusca = this.buscaUsuario

      this.quantidade = 0
      this.pagina = 1
      this.infiniteId = new Date()
      this.usuarios = []
    },

    limparFiltro: function () {
      this.filtroBusca = ''
      this.buscaUsuario = ''

      this.listarUsuarios()
    },

    confirmGerarAcesso: function (usuario) {
      customSwal.fire({
        icon: 'question',
        text: 'Deseja gerar uma link de acesso para este usuário?',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          UsuarioAPI.gerarAcesso(usuario.id).then(data => {
            loader.hide()
            Swal.fire({
              title: data.message,
              html: '<a target="_blank" href="' + data.link + '">' + data.link + '</a>',
              icon: 'success'
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      })
    },

    excluirUsuario: function (usuarioId) {
      customSwal.fire({
        icon: 'question',
        text: 'Deseja excluir da base o email desse usuário?',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          UsuarioAPI.excluirUsuario(usuarioId).then(data => {
            loader.hide()
            Swal.fire({
              title: '',
              html: 'Usuário/Email excluído com sucesso.',
              icon: 'success'
            })
            this.listarUsuarios()
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      })
    },
    validarEmail: function (usuarioId) {
      customSwal.fire({
        icon: 'question',
        text: 'Deseja validar o email desse usuário?',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          UsuarioAPI.validarEmail(usuarioId).then(data => {
            loader.hide()

            Swal.fire({
              title: '',
              html: 'Email validado com sucesso.',
              icon: 'success'
            })
            this.listarUsuarios()
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      })
    },
    definirSenha: function (usuario) {
      customSwal.fire({
        icon: 'question',
        text: 'Deseja gerar uma senha padrão de acesso para este usuário?',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          UsuarioAPI.definirSenha(usuario.id).then(data => {
            loader.hide()

            Swal.fire({
              title: data.message,
              html: '<p>' + usuario.email + ' / ' + data.retorno + '</>',
              icon: 'success'
            })
            this.listarUsuarios()
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      })
    }
  }
}
</script>

<style>
  h2 {
    border-left: 0px!important;
  }

  strong {
    font-weight: bold!important;
  }
</style>
